import React from 'react';
import { Row, Col, Collapse } from 'reactstrap';

export default ({
  className,
  isOpen,
  name,
  children,
}) => (
  <div className={className}>
    <h4
      className={[
        'm-0 text-white py-1 text-center',
        isOpen ? 'bg-dark' : 'bg-lightblue',
      ].join(' ')}
    >
      {name}
    </h4>
    <Collapse isOpen={isOpen}>
      <Row>
        <Col>{children}</Col>
      </Row>
    </Collapse>
  </div>
);
